import logger from './logger';
import LoggerRevista from './logs/revista';

export default function install(Vue, opts = {}) {
  const { env, router, store, EventBus } = opts;
  // Bootstrap Plugin
  // logger(env, router, store);
  LoggerRevista(opts);
}
